import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import ImageWithLoader from "shared/ui/image";
import ConfirmPasswordModal from "features/auth/components/ConfirmPasswordModal";
import { useModalManager } from "shared/hooks/useModalManager";
import { deleteCategory } from "../api/categoriesApi";
import { toast } from "react-toastify";

export default function DeleteCategoryModal({
  show,
  handleClose,
  category,
  onSaved,
}) {
  const [loading, setLoading] = useState(false);
  const { openModal, closeModal, currentModal } = useModalManager();

  // -------------------------------
  // Confirm password дээр OK дарсан дараах жинхэнэ устгах функц
  // -------------------------------
  const reallyDelete = async () => {
    if (!category?.id) return;

    try {
      setLoading(true);

      const result = await deleteCategory(category.id);

      if (result.success) {
        toast.success("Ангилал амжилттай устгагдлаа");
        closeModal(); // confirm-password дэд modal-ийг хаах
        onSaved?.(); // delete modal хаагаад жагсаалтыг refetch (reload оронд)
      } else {
        toast.error(result.message || "Устгах үед алдаа гарлаа");
      }
    } catch (e) {
      toast.error("Сервертэй холбогдож чадсангүй");
    } finally {
      setLoading(false);
    }
  };

  // -------------------------------
  // Устгах товч → эхлээд ConfirmPasswordModal нээнэ
  // -------------------------------
  const handleSubmit = () => {
    openModal("confirm-password");
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        onExit={() => {
          setLoading(false);
        }}
      >
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title className="text-white">Ангилал устгах</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center mt-3 ps-1 pe-1">
            <ImageWithLoader
              src={category?.imageUrl || category?.image}
              alt={category?.name}
              width="80px"
              height="80px"
              className="rounded-circle"
            />

            <h5 className="mt-3">
              Та <span className="fw-bold text-dark">{category?.name}</span>{" "}
              ангиллыг устгахдаа итгэлтэй байна уу?
            </h5>
            <p className="text-muted">
              Устгах үед түүнтэй холбоотой бүх дэд ангилал давхар устгагдах
              бөгөөд дахин сэргээх боломжгүйг анхаарна уу.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Болих
          </Button>

          <Button variant="danger" onClick={handleSubmit} disabled={loading}>
            Устгах
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirm Password */}
      <ConfirmPasswordModal
        show={currentModal === "confirm-password"}
        handleClose={closeModal}
        onSuccess={reallyDelete}
      />
    </>
  );
}
